import styled from '@emotion/styled'
import axios from 'axios'
import { Link } from 'gatsby'
import * as React from 'react'
import { useState } from 'react'
import ReactPaginate from 'react-paginate'

import Breadcrumbs from '../components/Breadcrumbs'
import Container from '../components/Container'
import Layout from '../components/Layout'
import { useQueryParam } from '../helpers'
import { SearchItemType } from '../types'
import Next from './../images/next.svg'
import Previous from './../images/prev.svg'

export const Title = styled.p({
    fontFamily: 'bold',
})

const SearchResult = (props: any) => {
    let abortController: AbortController
    const query = useQueryParam('query')

    const [searchQuery, setSearchQuery] = useState<string>('')

    const [isSearching, setSearching] = useState<boolean>(false)

    const [searchResults, setSearchResults] = useState<SearchItemType[]>([])
    const [value, setValue] = useState<SearchItemType[]>([])

    const numPage: number = 0

    //Paginate
    const [posts, setPosts] = useState<SearchItemType[]>([])
    const [loading, setLoading] = useState(false)
    const [currentPage, setCuurentPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(5)

    const section = styled.div`
        text-align: center;
    `

    const SumResult = styled.p`
        display: inline;
    `

    const Description = styled.p`
        height: 60px;
        line-height: 20px; /* Height /no. of lines to display */
        overflow: hidden;
        text-align: justify;
        text-overflow: ellipsis;
    `

    const LinkParaph = styled.div`
        grid-column: 1;
        grid-row: 1;
        min-width: 350px;
    `

    const Title = styled.div`
        grid-column: 1;
        grid-row: 2;
        min-width: 150px;
    `
    const ResultTitle = styled.div`
        grid-column: 4;
        grid-row: 1;
        min-width: 150px;
    `

    const SectionTitle = styled.div`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 1px;
        grid-auto-rows: minmax(50px, auto);
    `

    const runSearch = async (searchQuery: String) => {
        setSearching(true)

        abortController = new AbortController()

        return axios.get<SearchItemType[]>(
            `${process.env.GATSBY_STRAPI_API_URL ?? 'http://localhost:1337'}/search`,
            {
                params: {
                    _q: searchQuery,
                },
                signal: abortController.signal,
            },
        )
    }

    React.useEffect(() => {
        runSearch(query!!)
            .then((response: any) => {
                setSearchResults(response.data.hits.hits)
                setSearching(false)
                setValue(response.data)
            })
            .catch((ereason) => {
                setSearchResults([])
                setSearching(false)
            })

        const fetchPosts = async () => {
            setLoading(true)
            setPosts(searchResults)
            setLoading(false)
        }

        fetchPosts()
    }, [])

    const SectionSearch = styled.section((props) => {
        return {}
    })

    return (
        <Layout>
            <Breadcrumbs
                current={`Résultats des recherches pour "${query}"`}
                searchResultCount={searchResults.length}
            />
            <Container>
                <SectionSearch>
                    <PaginatedItems items={searchResults} itemsPerPage={5} />
                </SectionSearch>
            </Container>
        </Layout>
    )
}

function Items({ currentItems }: any) {
    const title = 'Resultat de la recherche'
    const Description = styled.p`
        overflow: hidden;
        text-align: justify;
        text-overflow: ellipsis;
        text-overflow: ellipsis;
        white-space: normal;
        margin-bottom: 48px !important;
    `

    const PathName = styled.p`
        padding-bottom: 10px;
        font-size: 16px;
    `

    const Test1 = styled.div`
        display: 'inline-block';
    `

    const Test2 = styled.div`
        margin-left: 'auto';
    `

    return (
        <ul>
            {currentItems.map((serviceItem: any) => (
                <li key={serviceItem._id}>
                    <Link to={serviceItem._source.path} style={{ cursor: 'pointer' }}>
                        {serviceItem._source.title}
                    </Link>
                    <PathName>{serviceItem._source.path}</PathName>
                    <Description>{serviceItem._source.summary}</Description>
                </li>
            ))}
        </ul>
    )
}

const PaginationWrapper = styled.div((props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: props.theme.spacing(20),

    ul: {
        margin: 0,
        listStyle: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        li: {
            margin: 0,
            lineHeight: 0,

            '&.previous, &.next': {
                margin: `0 ${props.theme.spacing(4)}`,
            },

            '&:not(.previous), &:not(.next)': {
                margin: `0 ${props.theme.spacing(2)}`,

                a: {
                    cursor: 'pointer',
                    textDecoration: 'none',
                    display: 'inline-block',
                    lineHeight: 0,
                },
            },

            a: {
                cursor: 'pointer',
                textDecoration: 'none',
                display: 'inline-block',
                lineHeight: 0,
            },
        },
    },
}))

const ResultWrapper = styled.div((props) => ({
    ul: {
        margin: 0,
        listStyle: 'none',

        li: {
            a: {
                textDecoration: 'none',
                fontSize: props.theme.spacing(3),
            },
        },
    },
}))

function PaginatedItems({ itemsPerPage, items }: any) {
    const [currentItems, setCurrentItems] = useState<number[]>([])
    const [pageCount, setPageCount] = useState(0)
    const [itemOffset, setItemOffset] = useState(0)

    const prev = <img src={Previous} alt="" />
    const next = <img src={Next} alt="" />

    React.useEffect(() => {
        const endOffset = itemOffset + itemsPerPage
        setCurrentItems(items.slice(itemOffset, endOffset))
        setPageCount(Math.ceil(items.length / itemsPerPage))
    }, [itemOffset, itemsPerPage])

    const handlePageClick = (event: any) => {
        const newOffset = (event.selected * itemsPerPage) % items.length
        setItemOffset(newOffset)
    }

    return (
        <>
            <ResultWrapper>
                <Items currentItems={currentItems} />
            </ResultWrapper>

            <PaginationWrapper>
                <ReactPaginate
                    breakLabel="..."
                    nextLabel={next}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={items.length}
                    pageCount={pageCount}
                    previousLabel={prev}
                    renderOnZeroPageCount={undefined}
                />
            </PaginationWrapper>
        </>
    )
}
export default SearchResult
